import React, {Component} from 'react';
import {DocType} from "../definitions/DocType";
import styled from "styled-components";
import {
  emptyICountSsqDataByDocType,
  emptySWSERVICECountOfEachDocTypeRequest,
  ICountOfEachDocTypeRequest,
  ICountsOfEachDocType,
  IGetSsqDataByPageRequest,
  ISsqDataDocument,
  SsqDataRepository
} from "../repositories/SsqDataRepository";
import {CategoryRepository} from "../repositories/category/CategoryRepository";
import {LanguageService} from "../language/LanguageService";
import CategoryStore from "../repositories/category/CategoryStore";
import {ErrorpageWrap, ViewmoreArea} from "../style/CommonStyledComponents";
import svcs from "services";
import {i18ns} from "language/i18nkey";
import {ISrchParam} from "productpage/ProductPage";
import {PERIOD_TYPE, SORT_TYPE} from "communitypage/common/CommunityFilter";
import {isEqual} from "lodash-es";
import {SsqImages} from "images/SsqImages";
import SwServiceDocListItem from "servicePage/swService/SwServiceDocListItem";
import {fontFamilyBold, fontFamilyMedium, fontFamilyRegular} from "style/fonts";
import img_icon_c_not_bad from "images/community/icon_c_not_bad.svg";
import {IfLoginInfo} from "models/IfLoginInfo";

interface Props {
  selectedCategoryId: number;
  languageService: LanguageService;
  categoryRepository: CategoryRepository;
  ssqDataRepository: SsqDataRepository;
  categoryStore: CategoryStore;
  getTranslation: Function;
  loadAllCategories: () => void;
  srchParam: ISrchParam;
  preSortType?: string;
  resetFilter?: Function;
  displayLoginPopup: Function;
  loginInfo?: IfLoginInfo;
}


interface State {
  selectedDocType: string;
  ssqDataDocuments: ISsqDataDocument[];
  ssqDataVersion: string;
  ssqDataDocumentsCounts: ICountsOfEachDocType;
  pageNum: number;
  isMounted: boolean;
}

class ProductSwServicePanel extends Component<Props, State> {
  private readonly NO_DATA = "NO_DATA";
  private readonly PAGE_NUM_UNIT = 20;

  constructor(props: Props) {
    super(props);
    this.state = {
      selectedDocType: DocType.SW_SERVICE,
      ssqDataDocuments: [],
      ssqDataVersion: "",
      ssqDataDocumentsCounts: emptyICountSsqDataByDocType,
      pageNum: 0,
      isMounted: false,
    };
  }

  async componentDidMount() {
    const {selectedCategoryId} = this.props;
    await this.getSsqDataDocumentsCounts(Number(selectedCategoryId));
    await this.getSsqDataDocuments(Number(selectedCategoryId));

    this.setState({pageNum: 0});

    this.setState({
      isMounted: true,
    });
  }

  async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    const selectedCategoryId = this.props.selectedCategoryId;

    if ((prevProps.selectedCategoryId !== selectedCategoryId) || !isEqual(prevProps.srchParam, this.props.srchParam)) {
      await this.setState({pageNum: 0});
      await this.getSsqDataDocumentsCounts(Number(selectedCategoryId));
      await this.getSsqDataDocuments(Number(selectedCategoryId));
    }

    if (prevState.selectedDocType != this.state.selectedDocType) {
      await this.getSsqDataDocuments(Number(selectedCategoryId));
      this.setState({pageNum: 0});
    }

    if (prevState.pageNum != this.state.pageNum && this.state.pageNum !== 0) {
      await this.getSsqDataDocuments(Number(selectedCategoryId), true);
    }

    if (prevProps.preSortType !== this.props.preSortType) {
      await this.setState({pageNum: 0});
      await this.getSsqDataDocuments(Number(selectedCategoryId));
    }
  }

  getDefaultSelectedTabForSampleTab(docCounts: ICountsOfEachDocType): string {
    return this.state.selectedDocType;

    if (docCounts.swServiceCount > 0)
      return DocType.SW_SERVICE;
  }

  async getSsqDataDocuments(categoryId: number, pageChanged: boolean = false) {
    if (this.state.selectedDocType !== this.NO_DATA) {
      let getSsqDataByPageRequest: IGetSsqDataByPageRequest = {
        ...emptySWSERVICECountOfEachDocTypeRequest,
        pageNum: this.state.pageNum,
        categoryId: categoryId,
        docTypes: [this.state.selectedDocType],
        exposeSiteLanguage: this.props.languageService.getLanguage(),
        sortType: this.props.srchParam.sortType === SORT_TYPE.RECENT ? 0 : this.props.srchParam.sortType === SORT_TYPE.UPDATE ? 1 : 2,
        periodType: this.props.srchParam.periodType === PERIOD_TYPE.DEFAULT ? 0 :
          this.props.srchParam.periodType === PERIOD_TYPE.WEEK ? 1 :
            this.props.srchParam.periodType === PERIOD_TYPE.ONEMONTH ? 2 :
              this.props.srchParam.periodType === PERIOD_TYPE.SIXMONTH ? 3 : 4,
        tagType: this.props.srchParam.tagType,
        keyword: this.props.srchParam.keyword,
        userId: this.props.loginInfo.userId,
      };

      let ssqDataDocuments = await this.props.ssqDataRepository.getSsqDataByPage(getSsqDataByPageRequest);
      console.log(ssqDataDocuments);
      if (this.state.pageNum > 0 && pageChanged) {
        this.setState({ssqDataDocuments: [...this.state.ssqDataDocuments, ...ssqDataDocuments]});
      } else {
        this.setState({ssqDataDocuments});
      }
    } else {
      this.setState({ssqDataDocuments: []});
    }
  }

  async getSsqDataDocumentsCounts(categoryId: number) {
    let countOfEachDocTypeRequest: ICountOfEachDocTypeRequest = {
      ...emptySWSERVICECountOfEachDocTypeRequest,
      categoryId: categoryId,
      exposeSiteLanguage: this.props.languageService.getLanguage(),
      periodType: this.props.srchParam.periodType === PERIOD_TYPE.DEFAULT ? 0 :
        this.props.srchParam.periodType === PERIOD_TYPE.WEEK ? 1 :
          this.props.srchParam.periodType === PERIOD_TYPE.ONEMONTH ? 2 :
            this.props.srchParam.periodType === PERIOD_TYPE.SIXMONTH ? 3 : 4,
      tagType: this.props.srchParam.tagType,
      keyword: this.props.srchParam.keyword,
      userId: this.props.loginInfo.userId
    };

    let ssqDataDocumentsCounts =
      await this.props.ssqDataRepository.getCountsOfEachDocType(countOfEachDocTypeRequest);
    console.log(ssqDataDocumentsCounts);

    this.setState({
      selectedDocType: this.getDefaultSelectedTabForSampleTab(ssqDataDocumentsCounts),
      ssqDataDocumentsCounts
    });
  }

  isMoreDocumentsOnNextPage(documentCount: number) {
    return documentCount > this.PAGE_NUM_UNIT * (this.state.pageNum + 1);
  }

  isRenderViewMoreSampleTab(docType: string) {
    if (docType === DocType.SW_SERVICE)
      return this.isMoreDocumentsOnNextPage(this.state.ssqDataDocumentsCounts.swServiceCount);
  }

  countDocTypeWithSsqDataDocumentAll(docType: string): number | undefined {
    if (docType === DocType.SW_SERVICE)
      return this.state.ssqDataDocumentsCounts.swServiceCount;
    else
      return 0;
  }

  getPageCount() {
    return this.PAGE_NUM_UNIT * (this.state.pageNum + 1);
  }

  getTotalCount() {
    return this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType);
  }

  clickedTag(tag) {
    console.log(tag);
  }

  docListItemTrans(key: string): string {
    svcs.svcLang.setNamespace(i18ns.svc);
    return svcs.svcLang.getTranslationByKey(key) || "";
  }

  renderNoDocumentPageReset() {
    return <ErrorpageWrap className={"ErrorpageWrap"}>
      <div className={"Errorpage"}>
        <img alt={"empty_search_result.svg"} src={SsqImages.common.icon.emptySearchResult()}/>
        <p className={"error-tit"}>{this.props.getTranslation("I18N_NO_DOCUMENT")}</p>
        <p className={"error-txt"}>{this.props.getTranslation("I18N_NO_DOCUMENT_NOTICE")}</p>
        {
          !isEqual(this.props.srchParam, {
            sortType: '',
            periodType: '',
            tagType: [],
            categoryId: 0,
            keyword: '',
          }) &&
          <button className="error-button" onClick={() => this.props.resetFilter()}>
            {this.props.getTranslation("I18N_NO_DOCUMENT_RESET")}
          </button>
        }
      </div>
    </ErrorpageWrap>;
  }


  renderNoDocumentPage() {
    return <ErrorpageWrap className={"ErrorpageWrap"}>
      <div className={"Errorpage-product"}>
        <img alt={"empty_search_result.svg"} src={SsqImages.common.icon.emptySearchResult()}/>
        <p className={"error-tit"}>{this.props.getTranslation("I18N_NO_DOCUMENT")}</p>
        <p className={"error-txt"}>{this.props.getTranslation("I18N_NO_DOCUMENT_NOTICE")}</p>
      </div>
    </ErrorpageWrap>;
  }


  selectDocTypeCountNoDocumentPage() {
    if ((this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType) === 0 && this.getTabCnt() !== 0 ||
      this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType) === 0) && this.props.srchParam.keyword !== "")
      return this.renderNoDocumentPageReset();

    if (this.props.srchParam.keyword == "" && (this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType) === 0 && this.getTabCnt() !== 0 ||
      this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType) === 0))
      return this.renderNoDocumentPage();
  }

  renderDocumentTable() {
    return <>
      <EmptySpace>
      </EmptySpace>
      <SwServiceContainer aria-label={"SwServicePage-page"}>
        <section className="store-body border-top-1 product-list">
          <div className={"wrapper container sub-container"}>
            <div className="store__content">
              <div className="content">
                <ul className="store-item">
                  {/*  문서 불러오는 부분*/}
                  {this.state.ssqDataDocuments.map((document) => {
                    return (<SwServiceDocListItem
                      displayLoginPopup={this.props.displayLoginPopup}
                      key={document.id}
                      clickedTag={this.clickedTag}
                      languageService={this.props.languageService}
                      ssqDocument={document}
                      getTranslation={this.docListItemTrans}/>);
                  })}
                </ul>
                {this.state.isMounted && this.selectDocTypeCountNoDocumentPage()}
              </div>
            </div>
          </div>
        </section>

      </SwServiceContainer>
    </>;
  }

  getTabCnt() {
    let cnt = 0;
    if (this.state.ssqDataDocumentsCounts.swServiceCount > 0) cnt = cnt + 1;
    return cnt;
  };

  render() {
    return (
      <div>
        {this.state.selectedDocType != this.NO_DATA
          &&
          <SubTabTableArea>
            {this.renderDocumentTable()}
            <div className={"sample-la"}>
              {this.isRenderViewMoreSampleTab(this.state.selectedDocType) && <ViewmoreArea className="view-more-area">
                <div className="view-more-list-box">
                  <div className={"ViewmoreBtn"}>
                    <button className={"view-more-button"} onClick={() => {
                      this.setState({pageNum: this.state.pageNum + 1});
                    }}>
                      {this.props.getTranslation("I18N_DOC_VIEW_MORE")}
                    </button>
                  </div>
                  <div className={"ViewmoreNum"}>
                    <span className={"page-count"}>{this.getPageCount()}</span>
                    <span>{this.getTotalCount()}</span>
                  </div>
                </div>
              </ViewmoreArea>
              }
            </div>
          </SubTabTableArea>
        }
      </div>
    );
  }
}

export default ProductSwServicePanel;

const EmptySpace = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 1.6rem;
  padding: 0 3rem;
  width: calc(100% - 26rem);
  min-height: 32px;

  @media screen and (max-width: 1199px) {

    margin-bottom: 8px;
    overflow: auto;
    padding: 2rem 0;

  }
  @media screen and (max-width: 764px) {
    padding: 2rem 16px;
    width: 100%;
    display: none;
  }
`;

const SubTabTableArea = styled.div`
  //display: flex;
  //flex-direction: column;

  .sample-la {
    width: 100%;
    background: #F7F8FB;
    margin-top: -4rem;
    padding-bottom: 3.2rem;

    .view-more-area {
      background: #F7F8FB;
    }

  }
`;


export const SwServiceContainer = styled.div`

  .lv-info {
    height: 1.8rem;
    line-height: 1.8rem;
    padding: 0 1rem;
    font-size: 1rem;
    border-radius: 2rem;
    display: inline-block;
    vertical-align: middle;
    margin: 0 0 0.4rem 0.4rem;
  }

  //내용 제목 임직원 타이틀 색상

  .lv-worker {
    background: #7783A1 !important;
    color: #fff !important;
  }

  .partner {
    display: inline-block;
    background: #F4B209;
    color: rgb(255, 255, 255);
    border-radius: 16px;
    //width: 4.8rem;
    padding: 0 0.8rem;
    height: 2rem;
    line-height: 2rem;
    font-size: 0.9rem;
    font-weight: bold;
    text-align: center;
    vertical-align: middle;
    margin-left: .6rem;
  }

  /* 하단 내용 CSS */

  .store__content > .content {
    padding: 3.2rem 2.4rem;
    width: 100%;
  }

  .store-item {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
  }

  .store-item > li {
    width: 36.4rem;
    display: flex;
    background: #fff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 0.5rem;
    margin: 0 1rem;
    margin-bottom: 2.2rem;
    box-sizing: border-box;
    flex-direction: column;
  }

  .store-card-body {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .store-content {
    flex-grow: 1;
  }

  .store-item > li .store-card-body {
    width: 100%;
  }

  .store-item > li .store-card-body .store-card-header {
    display: flex;
  }

  .store-item > li .tag {
    margin-top: 1rem;
    padding-left: 1.6rem;
    padding-right: 1.6rem;
  }

  .store-item > li .tag span {
    color: #407DD8;
    font-size: 1.3rem;
    margin-right: 1.2rem;
    ${fontFamilyRegular};
    line-height: 2.6rem;
    display: inline-block;
  }

  .store-item > li .tag span.sample-kind {
    color: #003378;
    font-size: 1rem;
    padding: 0 .8rem;
    height: 2rem;
    line-height: 1.8rem;
    border: .1rem solid #C7D6EA;
    border-radius: 10rem;
  }

  .store-item > li .store-title > p.title {
    color: #2A2C2F;
    font-size: 1.8rem;
    ${fontFamilyBold};
    line-height: 2.8rem;
    margin-top: 1.4rem;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    cursor: pointer;
    padding-left: 1.6rem;
    padding-right: 1.6rem;

    .search_highlight {
      background: linear-gradient(to top, #FFFAA0 50%, transparent 50%) !important;
    }

  }

  .store-item > li p.write-version {
    color: #7783a1;
    ${fontFamilyRegular};
    font-size: 1.2rem;
    line-height: 1.6rem;
    margin-top: .8rem;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    cursor: pointer;
    padding-left: 1.6rem;
    padding-right: 1.6rem;

    .search_highlight {
      background: linear-gradient(to top, #FFFAA0 50%, transparent 50%) !important;
    }
  }

  .store-item > li p.write-content {
    color: #2A2C2F;
    ${fontFamilyRegular};
    font-size: 1.3rem;
    line-height: 2rem;
    margin-top: .8rem;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    //-webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    cursor: pointer;
    padding-left: 1.6rem;
    padding-right: 1.6rem;
    padding-bottom: 1.6rem;
    white-space: pre-line;

    .search_highlight {
      background: linear-gradient(to top, #FFFAA0 50%, transparent 50%) !important;
    }
  }

  .swService-button {

    display: flex;
    text-align: center;
    min-width: 3.6rem;
  }

  .swService-line {
    background: #26282E;
  }


  .swService-button-text1 {
    width: 100%;
    background: #41444A;
    color: white;
    min-width: 3.6rem;
    min-height: 4.8rem;
    text-align: left;
    border-right: 1px solid #26282E;
    font-size: 1.4rem;
    padding-left: 20px;

    :first-child {
      width: 100%;
      border-radius: 0 0 0 .5rem;
    }
  }

  .img-button1 {
    float: right;
    margin-right: 12px;
    margin-top: 0.2rem;
  }

  .img-button {
    float: right;
    margin-right: 12px;
    transform: rotate(270deg);
    margin-top: .9rem;
  }

  .img-button2 {
    float: right;
    margin-right: 12px;
    background: url("${img_icon_c_not_bad}") no-repeat left center;
  }

  .swService-button-text2 {

    width: 100%;
    background: #41444A;
    color: white;
    min-width: 3.6rem;
    min-height: 4.8rem;
    text-align: left;
    line-height: 2.5rem;
    font-size: 1.4rem;
    padding-left: 20px;

    :last-child {
      width: 100%;
      border-radius: 0 0 .5rem 0;
    }


    :first-child:nth-last-child(1) {
      width: 100%;
      border-radius: 0 0 .5rem .5rem;
      text-align: center;
    }
  }

  .logo-img {
    width: 36.4rem;
    height: 10.8rem;
    flex-shrink: 0;
    cursor: pointer;

    img {
      width: 100%;
      max-height: 10.8rem;
      object-fit: cover;
      border-radius: 0.5rem 0.5rem 0 0;
    }
  }


  @media (min-width: 768px) and (max-width: 1199px) {


    .store__content {
      display: flex;
      flex-wrap: wrap;
    }

    .store__content > .content {
      padding: 3.2rem;
      padding-bottom: 3.2rem;
      width: 100%;
    }

  }

  @media screen and (max-width: 764px) {

    .store__content {
      display: flex;
      flex-direction: column;
    }

    .store__content > .content {
      padding: 1.6rem;
      padding-bottom: 3.2rem;
      width: 100%;
    }

    div {
      width: 100%;
    }

    .swService-button {
      width: 100%;
    }

    .swService-button-text1 {
      margin: 0;
    }

    .swService-button-text2 {
      margin: 0;
    }

    .swService-line {
      background: #26282E;
      width: .2rem;
    }

    .store-item > li {
      width: 100%;
      margin: 0 0 1.6rem 0;
    }

    .store-item > li .tag span {
      color: #407DD8;
      font-size: 1.3rem;
      margin-right: 1.2rem;
      ${fontFamilyMedium};
    }

    .logo-img {
      height: 10.8rem;
      width: 100%;
    }


  }

  /*상단 뒷 배경화면 전체 css*/

  section.store-body {
    background: #EEF1F6;
    position: relative;
    min-height: calc(100% - 60px);
  }

  section.store-body.border-top-1 {
    border-top: .1rem solid #C7D6EA;
    background: #F7F8FB;
    min-height: 60rem;
  }

  .sub-container {
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  }


  /*---------- 타블렛 사이즈 ----------*/
  @media (min-width: 768px) and (max-width: 1199px) {
  }

  /*---------- 모바일 사이즈 ----------*/
  @media screen and (max-width: 764px) {

    section.store-body.product-list {
      margin-top: 4rem;
    }

  }
}
`;